import { isLocal, isProduction } from '@/config/env';

export const getCookie = (name: string) => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1];
};

export const setCookie = (
  name: string,
  value: string,
  options?: {
    domain?: string;
    path?: string;
    expires?: Date;
    secure?: boolean;
    sameSite?: 'Strict' | 'Lax' | 'None';
  },
) => {
  const {
    domain = isLocal() ? '' : `.${location.host}`, // 默认设置为顶级域名，允许所有子域名访问
    path = '/',
    expires = new Date(Date.now() + 1 * 365 * 24 * 60 * 60 * 1000), // 默认1年后过期，实现永不过期效果
    secure = isProduction(),
    sameSite = 'Lax',
  } = options || {};

  let cookieString = `${name}=${value}`;

  if (domain) cookieString += `; domain=${domain}`;
  if (path) cookieString += `; path=${path}`;
  if (expires) cookieString += `; expires=${expires.toUTCString()}`;
  if (secure) cookieString += '; secure';
  if (sameSite) cookieString += `; samesite=${sameSite}`;

  document.cookie = cookieString;
};

export const removeCookie = (name: string) => {
  // 删除所有名为 name 的 cookies，不考虑 domain
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  document.cookie = `${name}=; path=/; domain=${location.host}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  document.cookie = `${name}=; path=/; domain=.${location.host}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
